/* Data Vandals — hover-to-play video cards.
 *
 * Two traps, both learned the hard way, both guarded here:
 *
 *   1. v.load() immediately before v.play() aborts the play request.
 *      So the source stays attached at preload="metadata" and we never
 *      call load() in the hover path.
 *
 *   2. Setting v.currentTime in the same tick as v.play() ALSO aborts it
 *      (AbortError). Cards with a non-zero in-point failed silently this
 *      way. So we seek first, wait for 'seeked', then play.
 */
(function () {
  var root = document.querySelector('.dv-vgrid-section');
  var cards = document.querySelectorAll('.dv-vcard[data-in]');
  if (!cards.length) return;

  var hold = Math.max(300, (parseFloat(root && root.dataset.viewhold) || 1.3) * 1000);
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function views(card) { return card.querySelectorAll('.dv-view'); }

  function showView(card, n) {
    var vs = views(card);
    if (!vs.length) return;
    var i = ((n % vs.length) + vs.length) % vs.length;
    card._viewIdx = i;
    for (var k = 0; k < vs.length; k++) vs[k].classList.toggle('is-on', k === i);
  }

  function startCycle(card) {
    stopCycle(card);
    if (views(card).length < 2 || reduce) return;
    card._viewTimer = setInterval(function () {
      showView(card, (card._viewIdx || 0) + 1);
    }, hold);
  }

  function stopCycle(card) {
    if (card._viewTimer) { clearInterval(card._viewTimer); card._viewTimer = null; }
  }

  function attempt(card, v) {
    var p = v.play();
    if (!p || !p.catch) return;
    p.catch(function () {
      // Not enough buffered yet. Wait for data, then try once more —
      // but only if the pointer is still on the card.
      v.addEventListener('canplay', function () {
        if (card.dataset.playing !== 'true') return;
        var q = v.play();
        if (q && q.catch) q.catch(function () {});
      }, { once: true });
    });
  }

  function wake(card) {
    if (reduce) return;
    var v = card.querySelector('.dv-vcard__video');
    if (!v) return;

    card.dataset.playing = 'true';
    v.muted = true;
    startCycle(card);

    var start = parseFloat(card.dataset.in) || 0;
    var len = parseFloat(card.dataset.length) || 4;
    var t = v.currentTime;

    if (t < start - 0.05 || t > start + len) {
      v.addEventListener('seeked', function () {
        if (card.dataset.playing === 'true') attempt(card, v);
      }, { once: true });
      try { v.currentTime = start; } catch (e) { attempt(card, v); }
    } else {
      attempt(card, v);
    }
  }

  function sleep(card) {
    var v = card.querySelector('.dv-vcard__video');
    card.dataset.playing = 'false';
    if (v) v.pause();
    stopCycle(card);
    showView(card, 0);
  }

  cards.forEach(function (card) {
    var v = card.querySelector('.dv-vcard__video');
    if (!v) return;
    card._viewIdx = 0;

    var start = parseFloat(card.dataset.in) || 0;
    var len = parseFloat(card.dataset.length) || 4;

    // Park on the in-point as soon as metadata lands, so the idle frame is
    // the right one and the first hover has nothing to seek.
    v.addEventListener('loadedmetadata', function () {
      if (!v.duration) return;
      try { v.currentTime = Math.min(start, v.duration - 0.1); } catch (e) {}
    });

    // Hold playback inside the trimmed window. Only while actually playing —
    // resetting during startup is what aborted the play.
    v.addEventListener('timeupdate', function () {
      if (v.paused) return;
      if (v.currentTime >= start + len - 0.05) {
        try { v.currentTime = start; } catch (e) {}
      }
    });

    if (canHover) {
      card.addEventListener('pointerenter', function () { wake(card); });
      card.addEventListener('pointerleave', function () { sleep(card); });
      card.addEventListener('focus', function () { wake(card); });
      card.addEventListener('blur', function () { sleep(card); });
    }
  });

  // Touch has no hover, so play whichever card is centred in the viewport.
  if (!canHover && !reduce && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) wake(e.target); else sleep(e.target);
      });
    }, { threshold: 0.6 });
    cards.forEach(function (c) { io.observe(c); });
  }
})();
